import {
  useEffect, useMemo, useState,
} from 'react';
import { useTranslation } from 'react-i18next';

import { Metric } from 'utils/constants';

const useGetMetric = () => {
  const { t } = useTranslation();
  const [value, $value] = useState<string>('');

  useEffect(() => {
    const getSystemMetric = async () => {
      const systemMetric = await localStorage.getItem('metric');
      $value(systemMetric ?? 'Metric system');
    };

    getSystemMetric();
  }, []);

  const KgHa = useMemo(() => {
    if (value === 'Metric system') {
      return 'kg/ha';
    }

    return 'lb/ac';
  }, [value]);

  const kg = useMemo(() => {
    if (value === 'Metric system') {
      return 'kg';
    }

    return 'lb';
  }, [value]);

  const mtHa = useMemo(() => {
    if (value === 'Metric system') {
      return 't/ha';
    }

    return value === Metric.metric ? t('ton') : 'US ton' + '/ac';
  }, [value]);

  const mt = useMemo(() => {
    if (value === 'Metric system') {
      return 't';
    }

    return value === Metric.metric ? t('ton') : 'US ton';
  }, [value]);

  const ac = useMemo(() => {
    if (value === 'Metric system') {
      return 'ha';
    }

    return 'ac';
  }, [value]);

  return {
    ton: value === Metric.metric ? t('ton') : 'US ton',
    kgHa: KgHa,
    kg: kg,
    mtHa: mtHa,
    onlyMt: mt,
    onlyAc: ac,
    metricValue: value,
  };
};

export default useGetMetric;
